import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/services/jwt.service";
import ErrorService from "@/services/errors.service";

const AxiosCrawler = axios.create({
  headers: {
    'Authorization': `Basic ${btoa("Diginet:sUp3rD1g1N3t")}`
  }
});

const CrawlerService = {
  init() {
    this.setupHeaders();

    AxiosCrawler.interceptors.response.use(function(response) {
      return response;
    }, this.handleError);

    Vue.use(VueAxios, AxiosCrawler);
  },

  getBaseUrl() {
    return window.location.host == "localhost:8080"
      ? "http://localhost:8000"
      : "/crawler";
  },

  setupHeaders() {
    AxiosCrawler.defaults.baseURL = this.getBaseUrl();
    AxiosCrawler.defaults.headers.common[
      "BranchId"
    ] = `${JwtService.getBranchId()}`;
  },

  handleError(_error) {
    var error = _error;
    if (_error.response !== undefined) {
      error = _error.response;
    }

    ErrorService.http(error);
    return Promise.reject(error);
  },

  query(_resource, _data) {
    return AxiosCrawler.get(_resource, { params: _data });
  },

  download(_resource, _slug = "") {
    if (_slug == "") {
      return AxiosCrawler.get(`${_resource}`, {responseType: 'arraybuffer'});
    } else {
      return AxiosCrawler.get(`${_resource}/${_slug}`, {responseType: 'arraybuffer'});
    }
  },

  get(_resource, _slug = "") {
    if (_slug == "") {
      return AxiosCrawler.get(`${_resource}`);
    } else {
      return AxiosCrawler.get(`${_resource}/${_slug}`);
    }
  },

  post(_resource, _params) {
    return AxiosCrawler.post(`${_resource}`, _params);
  },

  put(_resource, _id, _params) {
    return AxiosCrawler.put(`${_resource}/${_id}`, _params);
  },

  patch(_resource, _id, _params) {
    return AxiosCrawler.patch(`${_resource}/${_id}`, _params);
  },

  delete(_resource, _id) {
    return AxiosCrawler.delete(`${_resource}/${_id}`);
  }
};

Vue.mixin({
  methods: {
    setupHeaders() {
      CrawlerService.setupHeaders();
    }
  }
});

export default CrawlerService;